// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pwa-install-banner {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 10px 14px;
    background: #ffffff;
    border-bottom: 1px solid #e0e0e0;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
    position: sticky;
    top: 0;
    z-index: 9999;
    width: 100%;
    box-sizing: border-box;

    &__dismiss {
        background: none;
        border: none;
        font-size: 20px;
        color: #888;
        cursor: pointer;
        padding: 0 4px;
        line-height: 1;
        flex-shrink: 0;

        &:hover {
            color: #333;
        }
    }

    &__icon {
        flex-shrink: 0;

        img {
            width: 48px;
            height: 48px;
            border-radius: 10px;
            object-fit: contain;
            border: 1px solid #eee;
        }
    }

    &__text {
        flex: 1;
        display: flex;
        flex-direction: column;
        min-width: 0;

        strong {
            font-size: 13px;
            font-weight: 600;
            color: #222;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
        }

        span {
            font-size: 11px;
            color: #666;
            margin-top: 2px;
            line-height: 1.3;
        }
    }

    &__btn {
        flex-shrink: 0;
        background: #4CAF50;
        color: #fff;
        border: none;
        border-radius: 20px;
        padding: 8px 18px;
        font-size: 13px;
        font-weight: 600;
        cursor: pointer;
        transition: background 0.2s;

        &:hover {
            background: #43a047;
        }
    }
}`, "",{"version":3,"sources":["webpack://./src/app/pwa-install-banner/pwa-install-banner.component.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,kBAAkB;IAClB,mBAAmB;IACnB,gCAAgC;IAChC,wCAAwC;IACxC,gBAAgB;IAChB,MAAM;IACN,aAAa;IACb,WAAW;IACX,sBAAsB;;IAEtB;QACI,gBAAgB;QAChB,YAAY;QACZ,eAAe;QACf,WAAW;QACX,eAAe;QACf,cAAc;QACd,cAAc;QACd,cAAc;;QAEd;YACI,WAAW;QACf;IACJ;;IAEA;QACI,cAAc;;QAEd;YACI,WAAW;YACX,YAAY;YACZ,mBAAmB;YACnB,mBAAmB;YACnB,sBAAsB;QAC1B;IACJ;;IAEA;QACI,OAAO;QACP,aAAa;QACb,sBAAsB;QACtB,YAAY;;QAEZ;YACI,eAAe;YACf,gBAAgB;YAChB,WAAW;YACX,mBAAmB;YACnB,gBAAgB;YAChB,uBAAuB;QAC3B;;QAEA;YACI,eAAe;YACf,WAAW;YACX,eAAe;YACf,gBAAgB;QACpB;IACJ;;IAEA;QACI,cAAc;QACd,mBAAmB;QACnB,WAAW;QACX,YAAY;QACZ,mBAAmB;QACnB,iBAAiB;QACjB,eAAe;QACf,gBAAgB;QAChB,eAAe;QACf,2BAA2B;;QAE3B;YACI,mBAAmB;QACvB;IACJ;AACJ","sourcesContent":[".pwa-install-banner {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 10px;\r\n    padding: 10px 14px;\r\n    background: #ffffff;\r\n    border-bottom: 1px solid #e0e0e0;\r\n    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);\r\n    position: sticky;\r\n    top: 0;\r\n    z-index: 9999;\r\n    width: 100%;\r\n    box-sizing: border-box;\r\n\r\n    &__dismiss {\r\n        background: none;\r\n        border: none;\r\n        font-size: 20px;\r\n        color: #888;\r\n        cursor: pointer;\r\n        padding: 0 4px;\r\n        line-height: 1;\r\n        flex-shrink: 0;\r\n\r\n        &:hover {\r\n            color: #333;\r\n        }\r\n    }\r\n\r\n    &__icon {\r\n        flex-shrink: 0;\r\n\r\n        img {\r\n            width: 48px;\r\n            height: 48px;\r\n            border-radius: 10px;\r\n            object-fit: contain;\r\n            border: 1px solid #eee;\r\n        }\r\n    }\r\n\r\n    &__text {\r\n        flex: 1;\r\n        display: flex;\r\n        flex-direction: column;\r\n        min-width: 0;\r\n\r\n        strong {\r\n            font-size: 13px;\r\n            font-weight: 600;\r\n            color: #222;\r\n            white-space: nowrap;\r\n            overflow: hidden;\r\n            text-overflow: ellipsis;\r\n        }\r\n\r\n        span {\r\n            font-size: 11px;\r\n            color: #666;\r\n            margin-top: 2px;\r\n            line-height: 1.3;\r\n        }\r\n    }\r\n\r\n    &__btn {\r\n        flex-shrink: 0;\r\n        background: #4CAF50;\r\n        color: #fff;\r\n        border: none;\r\n        border-radius: 20px;\r\n        padding: 8px 18px;\r\n        font-size: 13px;\r\n        font-weight: 600;\r\n        cursor: pointer;\r\n        transition: background 0.2s;\r\n\r\n        &:hover {\r\n            background: #43a047;\r\n        }\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
